type PaymentDocumentData = {
  id: number;
  fileUrl: string;
  comment: string;
  createdAt: string;
  payedAmount: number;
};

type ContractPaymentData = {
  id?: string;
  contractId: number;
  bank: string;
  accountNumber: string;
  documentNumber: string;
  dueDate: Date;
  amount: number;
  type: 'fee' | 'tuition';
  status: 'pending' | 'paid' | 'failed' | 'cancelled';
  payedAt: Date;
  paymentDocument?: PaymentDocumentData;
};

export const translatePaymentStatus = (status: string): string => {
  const statusMap: { [key: string]: string } = {
    pending: 'Pendiente',
    paid: 'Pagado',
    failed: 'Fallido',
    cancelled: 'Cancelado',
  };
  return statusMap[status] || status;
};

export const translatePaymentMethod = (status: string): string => {
  const statusMap: { [key: string]: string } = {
    check: 'Cheque',
    monthly: 'Mensualidad',
    credit: 'Crédito',
    debit: 'Débito',
    transfer: 'Transferencia',
  };
  return statusMap[status] || status;
};

type ContractWithUserData = {
  id: string;
  student: {
    name: string;
    lastname: string;
    rut: string;
  };
  academicYear: number;
  total: number;
  totalPaid: number;
  paymentStatus: 'pending' | 'paid';
  startDate: Date;
  paymentType: string;
};

const CONTRACT_PAYMENTS_UI = [
  {
    label: 'Fecha',
    key: 'startDate',
    showOnTable: true,
    showOnModal: false,
    typeField: 'shortDate',
    valueType: 'shortDate',
  },
  {
    label: 'Nombre',
    key: 'name',
    showOnTable: true,
    showOnModal: true,
    typeField: 'text',
    valueType: 'string',
  },
  {
    label: 'Apellido',
    key: 'lastname',
    showOnTable: true,
    showOnModal: true,
    typeField: 'text',
    valueType: 'string',
  },
  {
    label: 'Rut',
    key: 'rut',
    showOnTable: true,
    showOnModal: true,
    typeField: 'text',
    valueType: 'string',
  },
  {
    label: 'Monto',
    key: 'total',
    showOnTable: true,
    showOnModal: true,
    typeField: 'text',
    valueType: 'ccy',
  },
  {
    label: 'Monto pagado',
    key: 'totalPaid',
    showOnTable: true,
    showOnModal: true,
    typeField: 'text',
    valueType: 'ccy',
  },
  {
    label: 'Medio de pago',
    key: 'paymentMethod',
    showOnTable: true,
    showOnModal: true,
    typeField: 'text',
    valueType: 'string',
  },
  {
    label: 'Estado',
    key: 'status',
    showOnTable: true,
    showOnModal: true,
    typeField: 'text',
    valueType: 'string',
  },
  {
    label: 'Registrar pago',
    key: 'registerPayment',
    showOnTable: true,
    showOnModal: false,
    typeField: 'button',
    valueType: 'string',
  },
];

export {
  PaymentDocumentData,
  ContractPaymentData,
  ContractWithUserData,
  CONTRACT_PAYMENTS_UI,
};
